/* ── Shared mutable state between Gallery scene and HexField ──
   Gallery.tsx writes the active project's accent colour (linear RGB, matching the
   kiln rim) so the HexField hex-portal particles glow in the same colour. */

// cells[0],cells[1] = the Forge Line's empty centre-stage centre (viewport
// fraction, y-up), republished by Gallery each frame so the standing hexagon
// sits exactly in the centre column. (Remaining slots are legacy/unused.)
const DEFAULT_CELLS = new Float32Array([
  -0.03, 0.0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0,
])

export const galleryStore = {
  r: 1,
  g: 0.42,
  b: 0,
  /** Active/hovered project index */
  index: 0,
  /** 9 hex-cell centres as viewport fractions [x0,y0, x1,y1, …] (centered, y-up). */
  cells: DEFAULT_CELLS,
  /** Hovered cell index (-1 = none). */
  active: -1,
  /** Active project's accent colour (hex) — the hexagon sweeps to this on change. */
  activeColor: '#ff6b00',
  /** Colour-sweep duration in seconds (Gallery sets this to ~0 for reduced motion). */
  sweepDur: 0.62,
  /** Centre-stage width as a viewport fraction — sizes the hexagon to its column so it
   *  stays consistent on big screens (the band is capped, so this shrinks as screens grow). */
  stageW: 0.28,
}
